<template>
  <Modal
    v-model="_value"
    width="500"
    title="首航设置车辆信息"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Form ref="setDriverCardParamsRef" v-model="setDriverCardParams" :label-width="80">
      <FormItem prop="possword" label="设备运营密码（设备密码）">
        <Input v-model="setDriverCardParams.possword" placeholder="请输入驾驶证号">
        </Input>
      </FormItem>
<!--      <FormItem prop="registrationColor" label="车牌颜色">-->
<!--        <Input v-model="setDriverCardParams.registrationColor" placeholder="请输入车牌颜色">-->
<!--        </Input>-->
<!--      </FormItem>-->
      <FormItem prop="color" label="车牌颜色">
        <Select class="field" v-model="setDriverCardParams.registrationColor">
          <Option v-for="item in registrationColorOptions" :value="item.value" :key="item.value">
            {{item.label}}
          </Option>
        </Select>
      </FormItem>
      <FormItem prop="registrationNum" label="车牌号">
        <Input v-model="setDriverCardParams.registrationNum" placeholder="请输入车牌号">
        </Input>
      </FormItem>
      <FormItem prop="vin" label="车架号">
        <Input v-model="setDriverCardParams.vin" placeholder="请输入车架号">
        </Input>
      </FormItem>
      <FormItem prop="engineNum" label="发动机">
        <Input v-model="setDriverCardParams.engineNum" placeholder="请输入发动机">
        </Input>
      </FormItem>
      <FormItem prop="vehicleType" label="车辆类型">
        <Input v-model="setDriverCardParams.vehicleType" placeholder="请输入车辆类型">
        </Input>
      </FormItem>
      <Button type="primary" @click="onCleanDriverCardParams" style="margin-right: 5px;">清空</Button>
      <Button type="primary" @click="onSendDriverCardParams">发送</Button>
    </Form>
  </Modal>
</template>

<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'


export default {
  name: 'shsetdrivervehicleinfomodal',
  props: {
    initValue: null,
    terminalNumValue: null,
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      setDriverCardParams: {
        id: null,
        possword: '092311',
        registrationColor: '黄色',
        registrationNum: '',
        vin: '',
        engineNum: '',
        vehicleType: '',
      },

      registrationColorOptions: [
        { label: '蓝色', value: 1 },
        { label: '黄色', value: 2 },
        // { label: '黑色', value: 3 },
        // { label: '白色', value: 4 },
        // { label: '渐变绿色', value: 5 },
        // { label: '黄绿色', value: 6 },
      ],
    }
  },
  methods: {
    ...mapActions([
    ]),
    visibleChange (val) {
      if (val) {
        this.setDriverCardParams.id = this._initValue
        this.setDriverCardParams.registrationColor = ''
        this.setDriverCardParams.registrationNum = ''
        this.setDriverCardParams.vin = ''
        this.setDriverCardParams.engineNum = ''
        this.setDriverCardParams.vehicleType = ''

        store.dispatch('PositioningDeviceInfoServ_SearchByName',{
          params:{
            name: this._terminalNumValue
          },
          urlparams:null,
        }).then(res =>{
          if (store.getters.get_PositioningDeviceInfo_SearchByNameResult && store.getters.get_PositioningDeviceInfo_SearchByNameResult.length >0){
            console.log(store.getters.get_PositioningDeviceInfo_SearchByNameResult)
            let vehicleInfoId = store.getters.get_PositioningDeviceInfo_SearchByNameResult[0].vehicleInfoId
            if (vehicleInfoId!=null){
              store.dispatch('VehicleInfoServ_GetDetail',{
                params:{
                  id: vehicleInfoId
                },
                urlparams:null
              }).then(res =>{
                if (store.getters.get_VehicleInfo_GetDetailResult){
                  let vehicleInfo = store.getters.get_VehicleInfo_GetDetailResult
                  this.setDriverCardParams.vin = vehicleInfo.vin
                  this.setDriverCardParams.registrationNum = vehicleInfo.registrationNum
                  if (vehicleInfo.vehicleType != null){
                    this.setDriverCardParams.vehicleType = vehicleInfo.vehicleType.name
                  }
                }
              }).catch(err =>{

              })

            } else {
              // console.log(store.getters.get_PositioningDeviceInfo_SearchByNameResult[0].installOrderId)
              store.dispatch('InstallOrderServ_GetDetail',{
                params:{
                  id: store.getters.get_PositioningDeviceInfo_SearchByNameResult[0].installOrderId
                },
                urlparams:null
              }).then(res =>{
                if (store.getters.get_InstallOrder_GetDetailResult){
                  let installOrder = store.getters.get_InstallOrder_GetDetailResult
                  this.setDriverCardParams.vin = installOrder.tempVehicleInfo.vin
                  this.setDriverCardParams.registrationNum = installOrder.tempVehicleInfo.registrationNum
                  if (installOrder.tempVehicleInfo.vehicleType != null){
                    this.setDriverCardParams.vehicleType = installOrder.tempVehicleInfo.vehicleType.name
                  }
                }
              }).catch(err =>{

              })
            }
          }
        }).catch(err =>{

        })


      }
    },
    onCleanDriverCardParams () {
      this.setDriverCardParams.registrationColor = ''
      this.setDriverCardParams.registrationNum = ''
      this.setDriverCardParams.vin = ''
      this.setDriverCardParams.engineNum = ''
      this.setDriverCardParams.vehicleType = ''
    },

    onSendDriverCardParams () {

      if (this.setDriverCardParams.registrationColor == '' || this.setDriverCardParams.registrationColor == null){
        this.$Message.error('车牌颜色不能为空')
        return
      }
      if (this.setDriverCardParams.registrationNum == '' || this.setDriverCardParams.registrationNum == null){
        this.$Message.error('车牌号不能为空')
        return
      }
      if (this.setDriverCardParams.vin == '' || this.setDriverCardParams.vin == null){
        this.$Message.error('车架号不能为空')
        return
      }
      if (this.setDriverCardParams.engineNum == '' || this.setDriverCardParams.engineNum == null){
        this.$Message.error('发动机号不能为空')
        return
      }
      if (this.setDriverCardParams.vehicleType == '' || this.setDriverCardParams.vehicleType == null){
        this.$Message.error('车辆类型不能为空')
        return
      }

      //(SH$P:运营商密码&V:车牌颜色,车牌号,VIN号,发动机号,车辆类型,0&RST)
      //(SH$P:092311&V:2,粤B12345,123456737G8034101,K1234567,重型半挂牵引车,*&RST)
      let content = null
      content = '(SH$P:' + this.setDriverCardParams.possword + '&V:' + this.setDriverCardParams.registrationColor + ','  + this.setDriverCardParams.registrationNum + ','  + this.setDriverCardParams.vin + ',' + this.setDriverCardParams.engineNum + ',' + this.setDriverCardParams.vehicleType + ',*&RST)'

      store.dispatch('NetCommandServ_SendCommand', {
        params: { id: this._initValue, content: content, urgent: false }
      }).then(() => {
        this.$Message.success('发送成功')
      }).catch(err => {
        this.$Message.error(err)
      })

    },
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _terminalNumValue: {
      get () {
        return this.terminalNumValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
